import map from 'lodash/map';

import jStat from 'jstat';

import { change, reset } from 'redux-form';
import { round4 as round } from 'utilities/math';
import { samplingDistributions } from 'mobx-store';
import { getAlpha, getTailType } from './selectors';

import { SAMPLING_DISTRIBUTIONS_FORM as FORM } from '../names';

export const setSamplingDistributionsCutoffs = () => (dispatch, getState) => {
  const state = getState();

  const tailType = getTailType(state);

  const mean = samplingDistributions.dotsMean;
  const stdev = samplingDistributions.dotsStdev;

  const alpha = tailType === 'both'
    ? getAlpha(state) / 2
    : getAlpha(state);

  const cutoffs = {
    leftCutoff: round(jStat.normal.inv(alpha, mean, stdev)),
    rightCutoff: round(jStat.normal.inv(1 - alpha, mean, stdev))
  };

  dispatch(
    map(cutoffs, (cutoffValue, cutoffName) =>
      change(FORM, cutoffName, cutoffValue)
    )
  );
};

export const resetSamplingDistributionsForm = () => reset(FORM);
